import { FormattedMessage } from 'react-intl';
import React, { useMemo } from 'react';
import { CalculatedTksData } from './calculator-customs-delivery-block';
import { getCurrencySymbol, toMoney } from '../../../../utils/common.utils';
import { Button } from 'rsuite';

type CalculationResultCustomsDeliveryBlockProps = {
  calculationData: CalculatedTksData;
  submitButtonTitle: string;
  onSubmit: () => void;
};

const CalculationResultCustomsDeliveryBlock = ({
  calculationData,
  submitButtonTitle,
  onSubmit,
}: CalculationResultCustomsDeliveryBlockProps) => {
  const totalInRub = useMemo(() => {
    return (
      calculationData.fee.sum +
      calculationData.nds.sum +
      calculationData.tolls.reduce((acc, value) => {
        return acc + value.sum;
      }, 0)
    );
  }, [calculationData]);
  return (
    <div>
      <div className="mb-1 pb-1 fs-16 fw-600">
        <FormattedMessage
          defaultMessage="Общая сумма таможенных платежей товара"
          id="CalculationBlock.label.totalOrderCost"
          description="Заголовок на странице"
        />
      </div>
      <div className={' h-10 gap-2 p-2 d-flex flex-row border-bottom'}>
        <div className={'w-20'}></div>
        <div className={'w-20'}>Основа</div>
        <div className={'w-20'}>Ставка</div>
        <div className={'w-20'}>Сумма</div>
      </div>
      <div className={' gap-2 0 p-2 d-flex h-10 border-bottom'}>
        <div className={'pb-2 fw-600 w-20'}>Сборы</div>
        <div className={'w-20'}>{toMoney(calculationData?.fee.price)} ₽</div>
        <div className={'w-20'}>
          {calculationData?.fee.info
            ? calculationData.fee.info
                .toLowerCase()
                .replace(/(\d+)(?=\s*руб)/, (match) => toMoney(Number(match)))
                .replace('руб', ' ₽')
            : ''}
        </div>
        <div className={'w-20'}>{toMoney(calculationData?.fee.sum)} ₽</div>
      </div>

      {calculationData?.tolls.map((toll, index) => {
        return (
          <div key={index} className={' gap-2  p-2 h-10 d-flex border-bottom'}>
            <div className={'pb-2 fw-600 w-20'}>Пошлина</div>
            <div className={'w-20'}>
              {toMoney(toll.price)}
              {calculationData?.unit
                ? '/' + calculationData?.unit.toUpperCase()
                : ' ₽'}
            </div>

            <div className={'w-20'}>
              {toll.info && toll.info.includes('%')
                ? toll.info
                : toll.info.replace(
                    /(\d+(\.\d+)?)\s*([^\d\s%]+)/,
                    (_1, number, _2, unit) => `${number} ${unit}`,
                  )}
            </div>
            <div className={'w-20'}>{toMoney(toll.sum)} ₽</div>
          </div>
        );
      })}
      <div className={'gap-2  p-2 d-flex h-10 border-bottom'}>
        <div className={'pb-2 fw-600 w-20 pb-0 '}>НДС</div>
        <div className={'w-20'}>{toMoney(calculationData?.nds.price)} ₽</div>
        <div className={'w-20'}>{calculationData?.nds.info?.toLowerCase()}</div>
        <div className={'w-20'}>{toMoney(calculationData?.nds.sum)} ₽</div>
      </div>
      <div className={' gap-2  p-2 d-flex h-10'}>
        <div className={'pb-2 fw-600 w-20'}>Итого</div>
        <div className={'w-20'}></div>
        <div className={'w-20'}></div>
        <div className={'w-20'}>
          {toMoney(totalInRub)} {getCurrencySymbol('rub')}
        </div>
      </div>
      <div>
        <Button
          as="button"
          size={'lg'}
          className={'btn btn-success'}
          onClick={() => {
            onSubmit();
          }}
        >
          {submitButtonTitle}
        </Button>
      </div>
    </div>
  );
};

export default CalculationResultCustomsDeliveryBlock;
